/**--external-- */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

/**--internal-- */
import { getResolvedFieldLabel } from "Worksheet/modules/WorksheetUtils";
import { McqModes } from "Worksheet/modules/WorksheetConstants";

/**--relative-- */
import classes from "./MultiChoiceCheckList.scss";
import OptionsList from "./OptionsList";
import UIInputList from "./UIInputList";

class MultiChoiceCheckList extends PureComponent {
  constructor(props) {
    super(props);

    if (props.customRef) {
      props.customRef(this);
    }
  }

  isValid = () => {
    const { value, customValidation } = this.props;

    const customError = customValidation(value);
    if (customError != "") return 1;

    return 0;
  };

  updateInputFieldValue = (value, extraParams, isWarningReq = true) => {
    const { updateInputField, hasAddRemoveValues } = this.props;

    updateInputField?.({
      params: value,
      isMutation: true,
      isDebounce: !hasAddRemoveValues,
      extraParams,
      hasAddRemoveValues,
      isWarningReq,
    });
  };

  renderStudentAttempt = () => {
    const {
      value,
      fieldKey,
      mode,
      updateInputField,
      allowMultiSelect,
      showDocEditor,
    } = this.props;

    return (
      <OptionsList
        options={value}
        mode={mode}
        fieldKey={fieldKey}
        updateInputField={updateInputField}
        allowMultiSelect={allowMultiSelect}
        showDocEditor={showDocEditor}
      />
    );
  };

  renderView = () => {
    const {
      value,
      fieldKey,
      mode,
      isAiGeneratedField,
      allowMultiSelect,
      showDocEditor,
    } = this.props;

    return (
      <OptionsList
        options={value}
        mode={mode}
        fieldKey={fieldKey}
        isAiGeneratedField={isAiGeneratedField}
        allowMultiSelect={allowMultiSelect}
        showDocEditor={showDocEditor}
      />
    );
  };

  renderCreate = () => {
    const {
      value,
      onFocusInputField,
      onBlurInputField,
      fieldKey,
      showDocEditor,
    } = this.props;

    return (
      <UIInputList
        value={value}
        updateInputField={this.updateInputFieldValue}
        onFocusInputField={onFocusInputField}
        onBlurInputField={onBlurInputField}
        name={fieldKey}
        showDocEditor={showDocEditor}
      />
    );
  };

  renderHeader = () => {
    const { mode, t } = this.props;
    switch (mode) {
      case "create": {
        const headerSubTextClasses = classNames(
          classes.headerSubTextContainer,
          "text-body-2 text-textSubtle"
        );

        return (
          <div className={classes.headerContainer}>
            <div className={classes.leftContainer}>
              <div className="text-label-2">
                {getResolvedFieldLabel(t("worksheet:options"), true)}
              </div>
              <div className={headerSubTextClasses}>
                {t("worksheet:check_all_correct_answers")}
              </div>
            </div>
          </div>
        );
      }
      default:
        return null;
    }
  };

  renderContent = () => {
    const { mode } = this.props;
    switch (mode) {
      case "create":
        return this.renderCreate();
      case "edit":
      case "teacher-preview":
        return this.renderStudentAttempt();
      case "preview":
      case "evaluate":
      case "view":
      case "restricted-view":
        return this.renderView();
      default:
        return null;
    }
  };

  render() {
    return (
      <div className={classes.container}>
        {this.renderHeader()}
        {this.renderContent()}
      </div>
    );
  }
}

MultiChoiceCheckList.displayName = "MultiChoiceCheckList";

MultiChoiceCheckList.propTypes = {
  labelComponent: PropTypes.element,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  mode: PropTypes.oneOf(McqModes),
  allowMultiSelect: PropTypes.bool,
};

MultiChoiceCheckList.defaultProps = {
  allowMultiSelect: true,
};

export default MultiChoiceCheckList;
